import { render, staticRenderFns } from "./UpdateNoteToCustomerDialog.vue?vue&type=template&id=0d6e760a&"
import script from "./UpdateNoteToCustomerDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateNoteToCustomerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports